import React from "react";
import { __ } from '@wordpress/i18n';

const bg = `${EASYCOMMERCE.assets}admin/img/icons/bg.png`;

const Account = ({ isAPIKeyVisible , formValues, setFormValues }) => {

    return (
        <div
            className="bg-cover bg-center w-full flex flex-col items-center"
        >
            <h2 className='text-2xl font-inter text-ec-title font-medium mb-8'>{__('Account Setup', 'easycommerce')}</h2>
            <div className="w-full">
                {/* Name Input */}
                <div className="flex flex-col space-y-2 mb-6">
                    <label className="text-ec-body text-[16px] font-medium">
                        Your Name
                    </label>
                    <input
                        type="text"
                        name="easysuite-api-name"
                        className="easycommerce-wizard-input w-full"
                        placeholder="Enter your name"
                        value={formValues.name || ""}
                        onChange={(e) =>
                            setFormValues((prev) => ({ ...prev, name: e.target.value }))
                        }
                    />
                    <p className="text-ec-placeholder text-xs">
                        Please enter your full name.
                    </p>
                </div>

                {/* Email Input */}
                <div className="flex flex-col space-y-2 mb-6">
                    <label className="text-ec-body text-[16px] font-medium">
                        Your Email
                    </label>
                    <input
                        type="email"
                        name="easysuite-api-email"
                        className="easycommerce-wizard-input w-full"
                        placeholder="Enter your email"
                        value={formValues.email || ""}
                        onChange={(e) =>
                            setFormValues((prev) => ({ ...prev, email: e.target.value }))
                        }
                    />
                    <p className="text-ec-placeholder text-xs">
                        We'll send an API key to this email to connect your store to our system for easy, streamlined store management.
                    </p>
                </div>

                {isAPIKeyVisible && (
                    <div className="flex flex-col space-y-2 mb-6">
                        <label className="text-ec-body text-[16px] font-medium">
                            API Key
                        </label>
                        <input
                            type="text"
                            name="easysuite-api-apiKey"
                            className="easycommerce-wizard-input w-full"
                            placeholder="Enter your API key"
                            onChange={(e) =>
                                setFormValues((prev) => ({ ...prev, apiKey: e.target.value }))
                            }
                        />
                        <p className="text-ec-placeholder text-xs">
                            Please enter the API key just sent to the email you provided above.
                        </p>
                    </div>
                )}

                <div className="flex items-center space-y-2">
                    <p className="text-ec-placeholder text-[14px]">
                        <input
                            type="checkbox"
                            name="dont_share_data"
                            onChange={(e) =>
                                setFormValues((prev) => ({ ...prev, dont_share_data: e.target.value }))
                            }
                        />
                        I prefer not to <strong>share my anonymous usage data</strong>, even if it helps improve EasyCommerce.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Account;
